import {api, API_URL} from "../api";
import axios from "axios";

export default class AuthService {
    
    static async tgWebAppSignIn(auth_data) {
        return api.post('/tg-web-app-sign-in', {auth_data})
    }

    static async sendPhoneOtp(phone_number, platform) {
        return api.post('/phone-otp/send', {phone_number, platform})
    }

    static async verifyPhoneOtp(phone_number, otp) {
        return api.post('/phone-otp/verify', {phone_number, otp})
    }

    static async refreshWithCookie() {
        return axios.get(`${API_URL}/refresh`, {withCredentials: true})
    }

    static async refreshWithHeader(refreshToken) {
        return axios.get(`${API_URL}/tg-or-viewer-refresh`, {
            headers: {
                Authorization: `Bearer ${refreshToken}`
            }
        })
    }

    static async viewerSignIn(login, password) {
        return axios.post(`${API_URL}/viewer-sign-in`, {login, password})
    }

    static async signOut() {
        return axios.get(`${API_URL}/sign-out`, {withCredentials: true})
    }
}